import type { QuestionnaireState } from "../types";

export const questionnaireInitialState: QuestionnaireState = {
  config: {},
  sections: [],
  groups: {},
  validations: [],
  answers: {},
  answerTimestamps: {},
  visibility: {},
  errors: {},
  asyncErrors: {},
  currentSectionIndex: 0,
  lastViewedSectionIndex: 0,
  isValid: false,
  isEditing: false,
  selectedQuestion: null,
  changedQuestions: [],
  changedAssumptionGroupIndex: 0,
  confirmedAssumptionGroups: new Set<number>(),
  addressModes: {},
};
